import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PucaUndertakingService {

	constructor(public http: HttpClient) { }

	public saveApplication(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_HRD_PUCA + 'puca/saveApplication', payload)
	}

}
